import { render, staticRenderFns } from "./CsvTextForm.vue?vue&type=template&id=72797e84&scoped=true"
import script from "./CsvTextForm.vue?vue&type=script&lang=ts"
export * from "./CsvTextForm.vue?vue&type=script&lang=ts"
import style0 from "./CsvTextForm.vue?vue&type=style&index=0&id=72797e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72797e84",
  null
  
)

export default component.exports